<template>
  <v-card flat class="px-3">
    <v-form ref="buyerDataForm" v-model="buyerValid">
      <v-text-field
        v-show="!signSteps.logged && signSteps.step != 1"
        outline
        required
        label="Email"
        :readonly="natalLuzAgency"
        :disabled="pendingOrder && !firstPayment"
        v-model="email"
        :rules="
          $route.name !== 'totem' && $route.name !== 'commissioner'
            ? [email === emailConfirmation || 'Emails não correspondem']
            : []
        "
      ></v-text-field>

      <v-text-field
        v-show="
          !signSteps.logged &&
            signSteps.step != 1 &&
            $route.name !== 'totem' &&
            $route.name !== 'commissioner'
        "
        ref="confirmationMail"
        outline
        required
        :disabled="pendingOrder && !firstPayment"
        label="Confirme seu Email"
        v-model="emailConfirmation"
        :rules="[email === emailConfirmation || 'Emails não correspondem']"
      ></v-text-field>

      <v-text-field
        outline
        ref="buyerName"
        required
        :disabled="pendingOrder && !firstPayment"
        :readonly="natalLuzAgency"
        :rules="[rulesValidation.noSpecialChars]"
        :label="selectedDocument === 'cnpj' ? 'Razão Social' : 'Nome Completo'"
        v-model="name"
      ></v-text-field>
      <v-layout>
        <v-flex :class="$vuetify.breakpoint.mdAndUp ? 'xs6' : 'xs12'">
          <v-select
            outline
            class="pr-1"
            required
            :readonly="natalLuzAgency"
            :disabled="pendingOrder && !firstPayment"
            :items="documentos"
            v-model="selectedDocument"
            label="Documento"
            @change="setFocus"
          ></v-select>
        </v-flex>
        <v-flex
          v-if="selectedDocument === 'foreigner'"
          :class="$vuetify.breakpoint.mdAndUp ? 'xs6 px-2' : 'xs12'"
        >
          <v-autocomplete
            outline
            required
            label="Nacionalidade"
            :disabled="pendingOrder && !firstPayment"
            v-model="country"
            :items="countryList"
            item-text="nome"
            item-value="nome"
          ></v-autocomplete>
        </v-flex>
        <v-flex :class="$vuetify.breakpoint.mdAndUp ? 'xs6' : 'xs12'">
          <v-text-field
            ref="docnumber"
            class="pl-1"
            outline
            required
            :readonly="natalLuzAgency"
            :disabled="pendingOrder && !firstPayment"
            label="Número"
            v-model="document"
            :mask="validateMask()"
            :rules="validateRules()"
            return-masked-value
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-text-field
        outline
        required
        :readonly="natalLuzAgency"
        :disabled="pendingOrder && !firstPayment"
        label="Telefone"
        mask="(##) #####-####"
        v-model="phone"
        :rules="[(this.phone && this.phone.length > 10) || 'Telefone Inválido']"
      ></v-text-field>
      <div id="google-place"></div>
      <div id="google-autocomplete"></div>
      <div v-if="checkout_dados_nf === 2 && selectedDocument !== 'foreigner'">
        <v-autocomplete
          background-color="rgba(25,43,70,0.16)"
          outline
          label="Cidade/UF"
          v-model="locationModel"
          item-text="description"
          :item-value="valueFormated"
          browser-autocomplete="new-password"
          :items="eventPlaces"
          no-data-text="Digite para buscar o local"
          :disabled="pendingOrder && !firstPayment"
          :search-input.sync="location"
        ></v-autocomplete>
      </div>

      <div v-if="checkout_dados_nf && checkout_dados_nf === 3">
        <v-text-field
          outline
          :disabled="pendingOrder && !firstPayment"
          :label="
            selectedDocument === 'foreigner'
              ? 'Código Postal (Zip Code)'
              : 'CEP'
          "
          :mask="selectedDocument === 'foreigner' ? '' : '#####-###'"
          v-model="cep"
        ></v-text-field>
      </div>

      <div v-if="checkout_dados_nf && checkout_dados_nf === 4">
        <v-checkbox
          v-model="invoice"
          color="primary"
          label="Desejo nota fiscal desta compra"
          @change="handleChangeInvoice"
        ></v-checkbox>
      </div>

      <div
        v-if="
          (checkout_dados_nf && checkout_dados_nf === 1) ||
            (checkout_dados_nf === 4 && invoice)
        "
      >
        <v-text-field
          outline
          required
          :disabled="pendingOrder && !firstPayment"
          label="CEP"
          :mask="country !== 'Brasil' ? '' : '#####-###'"
          v-model="cep"
        ></v-text-field>
        <v-text-field
          outline
          required
          :disabled="pendingOrder && !firstPayment"
          label="Rua, Avenida..."
          v-model="address"
        ></v-text-field>
        <v-layout>
          <v-flex xs6>
            <v-text-field
              class="pr-1"
              outline
              required
              :disabled="pendingOrder && !firstPayment"
              label="Número"
              v-model="number"
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              class="pl-1"
              outline
              :disabled="pendingOrder && !firstPayment"
              label="Complemento"
              v-model="complement"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-text-field
          outline
          required
          :disabled="pendingOrder && !firstPayment"
          label="Bairro"
          v-model="neighborhood"
        ></v-text-field>
        <v-text-field
          outline
          required
          :disabled="pendingOrder && !firstPayment"
          label="Cidade"
          v-model="city"
        ></v-text-field>
        <v-text-field
          outline
          required
          :disabled="pendingOrder && !firstPayment"
          label="Estado"
          v-model="state"
        ></v-text-field>
        <v-autocomplete
          v-if="selectedDocument !== 'foreigner'"
          outline
          required
          label="País"
          :disabled="pendingOrder && !firstPayment"
          v-model="country"
          :items="countryList"
          item-text="nome"
          item-value="nome"
        ></v-autocomplete>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import validationMixin from '../../mixins/validationMixin';
import axios from 'axios';
export default {
  mixins: [validationMixin],
  data: () => ({
    buyerValid: false,
    invoice: false,

    location: '',
    locations: [],
    natalLuzAgency: false,
    documentos: [
      { text: 'CPF', value: 'cpf' },
      { text: 'CNPJ', value: 'cnpj' },
      { text: 'Estrangeiro (Foreigner)', value: 'foreigner' },
    ],
    required: [v => !!v || 'Campo obrigatório'],
    cnpjRule: [
      cnpj => {
        if (cnpj && cnpj.length) {
          cnpj = cnpj.replace(/[^\d]+/g, '');
          if (cnpj === '') return 'CNPJ inválido';

          if (cnpj.length !== 14) return 'CNPJ inválido';

          // Elimina CNPJs invalidos conhecidos
          if (
            cnpj === '00000000000000' ||
            cnpj === '11111111111111' ||
            cnpj === '22222222222222' ||
            cnpj === '33333333333333' ||
            cnpj === '44444444444444' ||
            cnpj === '55555555555555' ||
            cnpj === '66666666666666' ||
            cnpj === '77777777777777' ||
            cnpj === '88888888888888' ||
            cnpj === '99999999999999'
          )
            return 'CNPJ inválido';

          // Valida DVs
          let tamanho = cnpj.length - 2;
          let numeros = cnpj.substring(0, tamanho);
          let digitos = cnpj.substring(tamanho);
          let soma = 0;
          let pos = tamanho - 7;
          for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
          }
          let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
          if (parseInt(resultado) !== parseInt(digitos.charAt(0)))
            return 'CNPJ inválido';

          tamanho = tamanho + 1;
          numeros = cnpj.substring(0, tamanho);
          soma = 0;
          pos = tamanho - 7;
          for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
          }
          resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
          if (parseInt(resultado) !== parseInt(digitos.charAt(1)))
            return 'CNPJ inválido';

          return true;
        } else {
          return 'CNPJ inválido';
        }
      },
    ],
    cpfRule: [
      cpf => {
        let numeros;
        let digitos;
        let soma;
        let i;
        let resultado;
        let digitosIguais;
        digitosIguais = 1;
        cpf = cpf.replace(/-|\./g, '');
        if (cpf.length < 11) {
          return 'CPF inválido';
        }
        for (i = 0; i < cpf.length - 1; i++) {
          if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
            digitosIguais = 0;
            break;
          }
        }
        if (!digitosIguais) {
          numeros = cpf.substring(0, 9);
          digitos = cpf.substring(9);
          soma = 0;
          for (i = 10; i > 1; i--) {
            soma += numeros.charAt(10 - i) * i;
          }
          resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
          if (resultado !== parseInt(digitos.charAt(0))) {
            return 'CPF inválido';
          }
          numeros = cpf.substring(0, 10);
          soma = 0;
          for (i = 11; i > 1; i--) {
            soma += numeros.charAt(11 - i) * i;
          }
          resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
          if (resultado !== parseInt(digitos.charAt(1))) {
            return 'CPF inválido';
          }
          return true;
        }
        return 'CPF inválido';
      },
    ],
  }),
  computed: {
    ...mapGetters({
      eventName: 'eventName',
      eventPlaces: 'eventPlaces',
      checkout_dados_nf: 'checkout_dados_nf',
      userProps: 'userProps',
      signSteps: 'signSteps',
      productsTotal: 'productsTotal',
      countryList: 'countryList',
      pendingOrder: 'pendingOrder',
      cupomData: 'cupomData',
      cupomCode: 'cupomCode',
      buyerDataCommissary: 'buyerDataCommissary',
      firstPayment: 'firstPayment',
    }),
    email: {
      get() {
        return this.userProps.email;
      },
      set(val) {
        this.setUserProps({
          selectedDocument: this.selectedDocument,
          emailConfirmation: this.emailConfirmation,
          email: val,
          document: this.document,
          name: this.name,
          phone: this.phone,
          locationModel: this.locationModel,
          cep: this.cep,
          address: this.address,
          number: this.number,
          complement: this.complement,
          neighborhood: this.neighborhood,
          city: this.city,
          state: this.state,
        });
      },
    },
    document: {
      get() {
        return this.userProps.document;
      },
      set(val) {
        this.setUserProps({
          selectedDocument: this.selectedDocument,
          emailConfirmation: this.emailConfirmation,
          email: this.email,
          document: val,
          name: this.name,
          phone: this.phone,
          locationModel: this.locationModel,
          cep: this.cep,
          address: this.address,
          number: this.number,
          complement: this.complement,
          neighborhood: this.neighborhood,
          city: this.city,
          state: this.state,
          country: this.country,
        });
      },
    },
    selectedDocument: {
      get() {
        return this.userProps.selectedDocument;
      },
      set(val) {
        this.setUserProps({
          selectedDocument: val,
          emailConfirmation: this.emailConfirmation,
          email: this.email,
          document: this.document,
          name: this.name,
          phone: this.phone,
          locationModel: this.locationModel,
          cep: this.cep,
          address: this.address,
          number: this.number,
          complement: this.complement,
          neighborhood: this.neighborhood,
          city: this.city,
          state: this.state,
          country: this.country,
        });
      },
    },
    emailConfirmation: {
      get() {
        return this.userProps.emailConfirmation;
      },
      set(val) {
        this.setUserProps({
          selectedDocument: this.selectedDocument,
          emailConfirmation: val,
          email: this.email,
          document: this.document,
          name: this.name,
          phone: this.phone,
          locationModel: this.locationModel,
          cep: this.cep,
          address: this.address,
          number: this.number,
          complement: this.complement,
          neighborhood: this.neighborhood,
          city: this.city,
          state: this.state,
          country: this.country,
        });
      },
    },
    phone: {
      get() {
        return this.userProps.phone;
      },
      set(val) {
        this.setUserProps({
          selectedDocument: this.selectedDocument,
          emailConfirmation: this.emailConfirmation,
          email: this.email,
          document: this.document,
          name: this.name,
          phone: val,
          locationModel: this.locationModel,
          cep: this.cep,
          address: this.address,
          number: this.number,
          complement: this.complement,
          neighborhood: this.neighborhood,
          city: this.city,
          state: this.state,
          country: this.country,
        });
      },
    },
    name: {
      get() {
        return this.userProps.name;
      },
      set(val) {
        this.setUserProps({
          selectedDocument: this.selectedDocument,
          emailConfirmation: this.emailConfirmation,
          email: this.email,
          document: this.document,
          name: val,
          phone: this.phone,
          locationModel: this.locationModel,
          cep: this.cep,
          address: this.address,
          number: this.number,
          complement: this.complement,
          neighborhood: this.neighborhood,
          city: this.city,
          state: this.state,
          country: this.country,
        });
      },
    },
    cep: {
      get() {
        return this.userProps.cep;
      },
      set(val) {
        this.setUserProps({
          selectedDocument: this.selectedDocument,
          emailConfirmation: this.emailConfirmation,
          email: this.email,
          document: this.document,
          name: this.name,
          phone: this.phone,
          locationModel: this.locationModel,
          cep: val,
          address: this.address,
          number: this.number,
          complement: this.complement,
          neighborhood: this.neighborhood,
          city: this.city,
          state: this.state,
          country: this.country,
        });
      },
    },
    address: {
      get() {
        return this.userProps.address;
      },
      set(val) {
        this.setUserProps({
          selectedDocument: this.selectedDocument,
          emailConfirmation: this.emailConfirmation,
          email: this.email,
          document: this.document,
          name: this.name,
          phone: this.phone,
          locationModel: this.locationModel,
          cep: this.cep,
          address: val,
          number: this.number,
          complement: this.complement,
          neighborhood: this.neighborhood,
          city: this.city,
          state: this.state,
          country: this.country,
        });
      },
    },
    number: {
      get() {
        return this.userProps.number;
      },
      set(val) {
        this.setUserProps({
          selectedDocument: this.selectedDocument,
          emailConfirmation: this.emailConfirmation,
          email: this.email,
          document: this.document,
          name: this.name,
          phone: this.phone,
          locationModel: this.locationModel,
          cep: this.cep,
          address: this.address,
          number: val,
          complement: this.complement,
          neighborhood: this.neighborhood,
          city: this.city,
          state: this.state,
          country: this.country,
        });
      },
    },
    complement: {
      get() {
        return this.userProps.complement;
      },
      set(val) {
        this.setUserProps({
          selectedDocument: this.selectedDocument,
          emailConfirmation: this.emailConfirmation,
          email: this.email,
          document: this.document,
          name: this.name,
          phone: this.phone,
          locationModel: this.locationModel,
          cep: this.cep,
          address: this.address,
          number: this.number,
          complement: val,
          neighborhood: this.neighborhood,
          city: this.city,
          state: this.state,
          country: this.country,
        });
      },
    },
    neighborhood: {
      get() {
        return this.userProps.neighborhood;
      },
      set(val) {
        this.setUserProps({
          selectedDocument: this.selectedDocument,
          emailConfirmation: this.emailConfirmation,
          email: this.email,
          document: this.document,
          name: this.name,
          phone: this.phone,
          locationModel: this.locationModel,
          cep: this.cep,
          address: this.address,
          number: this.number,
          complement: this.complement,
          neighborhood: val,
          city: this.city,
          state: this.state,
          country: this.country,
        });
      },
    },
    city: {
      get() {
        return this.userProps.city;
      },
      set(val) {
        this.setUserProps({
          selectedDocument: this.selectedDocument,
          emailConfirmation: this.emailConfirmation,
          email: this.email,
          document: this.document,
          name: this.name,
          phone: this.phone,
          locationModel: this.locationModel,
          cep: this.cep,
          address: this.address,
          number: this.number,
          complement: this.complement,
          neighborhood: this.neighborhood,
          city: val,
          state: this.state,
          country: this.country,
        });
      },
    },
    state: {
      get() {
        return this.userProps.state;
      },
      set(val) {
        this.setUserProps({
          selectedDocument: this.selectedDocument,
          emailConfirmation: this.emailConfirmation,
          email: this.email,
          document: this.document,
          name: this.name,
          phone: this.phone,
          locationModel: this.locationModel,
          cep: this.cep,
          address: this.address,
          number: this.number,
          complement: this.complement,
          neighborhood: this.neighborhood,
          city: this.city,
          state: val,
          country: this.country,
        });
      },
    },
    country: {
      get() {
        return this.userProps.country;
      },
      set(val) {
        this.setUserProps({
          selectedDocument: this.selectedDocument,
          emailConfirmation: this.emailConfirmation,
          email: this.email,
          document: this.document,
          name: this.name,
          phone: this.phone,
          locationModel: this.locationModel,
          cep: this.cep,
          address: this.address,
          number: this.number,
          complement: this.complement,
          neighborhood: this.neighborhood,
          city: this.city,
          state: this.state,
          country: val,
        });
      },
    },
    locationModel: {
      get() {
        return this.userProps.locationModel;
      },
      set(val) {
        this.setUserProps({
          selectedDocument: this.selectedDocument,
          emailConfirmation: this.emailConfirmation,
          email: this.email,
          document: this.document,
          name: this.name,
          phone: this.phone,
          locationModel: val,
          cep: this.cep,
          address: this.address,
          number: this.number,
          complement: this.complement,
          neighborhood: this.neighborhood,
          city: this.city,
          state: this.state,
          country: this.country,
        });
      },
    },
  },
  mounted() {
    this.$store.dispatch('setPaymentOption', null);
    this.$store.dispatch('setCardName', '');
    this.$store.dispatch('setCardCPF', '');
    this.$store.dispatch('setCardNumber', '');
    this.$store.dispatch('setCardDate', '');
    this.$store.dispatch('setCardCVC', '');
    this.selectedDocument = 'cpf';
    if (this.$route.name === 'commissioner' && this.buyerDataCommissary) {
      console.log('to aqui');

      let formatedDocument = '';
      if (this.buyerDataCommissary.documento) {
        formatedDocument = this.buyerDataCommissary.documento
          .replaceAll('-', '')
          .replaceAll('/', '')
          .replaceAll('.', '');
      }

      if (this.buyerDataCommissary.cidade) {
        this.location = this.buyerDataCommissary.cidade;
        setTimeout(() => {
          this.locationModel = `${this.buyerDataCommissary.cidade}/${this.buyerDataCommissary.uf}/${this.buyerDataCommissary.pais}`;
        }, 0);
      }

      console.log(this.locationModel, this.buyerDataCommissary);
      this.setUserProps({
        name: this.buyerDataCommissary.nome,
        email: this.buyerDataCommissary.email,
        phone: this.buyerDataCommissary.telefone,
        emailConfirmation: this.buyerDataCommissary.email,
        selectedDocument:
          formatedDocument && formatedDocument.length === 11
            ? 'cpf'
            : formatedDocument
            ? 'cnpj'
            : 'cpf',
        document: formatedDocument,
      });
    }
    if (this.cupomData && this.cupomData.campaign_name === 'Agências') {
      this.natalLuzAgency = true;
      this.name = this.cupomData.name;
      this.email = this.cupomData.email;
      this.phone = this.cupomData.phone;
      this.selectedDocument = 'cnpj';
      this.document = this.cupomData.document;
    }
    if (
      !this.cupomCode &&
      this.eventName &&
      this.eventName.includes('Natal Luz')
    ) {
      this.documentos = [
        { text: 'CPF', value: 'cpf' },
        { text: 'Estrangeiro (Foreigner)', value: 'foreigner' },
      ];
    }
    if (!this.signSteps.logged && this.signSteps.step !== 1) {
      this.$refs.confirmationMail.focus();
    } else {
      this.$refs.buyerName.focus();
      this.emailConfirmation = this.email;
    }
    this.country = 'Brasil';
  },
  methods: {
    ...mapActions({
      setUserProps: 'setUserProps',
    }),
    async searchLocation(v) {
      await this.$store.dispatch('getGlobalPlaces', v);
    },
    valueFormated(v) {
      let valueReplace = v.description.split(' - ');
      return `${valueReplace[0]}/${valueReplace[1]}/${valueReplace[2]}`;
    },
    validateMask() {
      if (this.selectedDocument === 'cpf') return '###.###.###-##';
      else if (this.selectedDocument === 'cnpj') return '##.###.###/####-##';
      else return '';
    },
    validateRules() {
      if (this.selectedDocument === 'cpf') return this.cpfRule;
      else if (this.selectedDocument === 'cnpj') return this.cnpjRule;
      else return this.required;
    },
    setFocus() {
      this.document = '';
      if (this.selectedDocument === 'foreigner') this.cep = '';
      this.$refs.docnumber.focus();
    },
    handleChangeInvoice() {
      this.$store.commit('SET_INVOICE', this.invoice);
    },
  },
  watch: {
    location(v) {
      if (v && v.length >= 3) {
        this.searchLocation(v);
      } else this.$store.commit('SET_ALL_EVENT_PLACES', []);
    },
    async cep(v) {
      if (v && v.length === 8 && this.country === 'Brasil') {
        await axios
          .get(`https://viacep.com.br/ws/${v}/json/`)
          .then(response => {
            if (response.status === 200 && !response.data.erro) {
              this.neighborhood = response.data.bairro;
              this.address = response.data.logradouro;
              this.city = response.data.localidade;
              this.state = response.data.uf;
            } else {
              this.neighborhood = '';
              this.address = '';
              this.city = '';
              this.state = '';
            }
          });
      }
    },
    countryList() {
      this.country = 'Brasil';
    },
  },
};
</script>
